import $ from "jquery";
import moment from "moment-timezone";

import { USER_ACTION_STATE } from "lib/constants";
import wsStorage from "lib/wsStorage";

export default () => {
    const $tosUpdate = $("#tos-update-dialog");
    if ($tosUpdate.length) {
        const markUpdateSeen = () => {
            $.ajax({
                url: "/api/hire/v1/user-action/",
                type: "PATCH",
                data: JSON.stringify({
                    action_state: USER_ACTION_STATE.TOS_PRIVACY_UPDATE,
                }),
                dataType: "json",
                contentType: "application/json",
            });
        };

        const key = "tosupdate";
        const seen = wsStorage.getItem(key) || null;

        const sectionToShow = moment().isBefore(moment("2021-10-11"))
            ? ".tos-update-dialog__before"
            : ".tos-update-dialog__after";

        $tosUpdate.find(sectionToShow).show();
        $tosUpdate.find(".btn").on("click", () => {
            if (!seen) {
                markUpdateSeen();
            }
            $tosUpdate.fadeOut();
        });

        if (seen) {
            // Mark it seen the second time we show it, even if they haven't clicked.
            markUpdateSeen();
        } else {
            wsStorage.setItem(key, true, 86400 * 30);
        }

        setTimeout(() => {
            $tosUpdate.fadeIn();
        }, 1000);
    }
};
